import { makeStyles } from '@material-ui/core'

const useSelectStyles = makeStyles({
  menuSelect: {
    width: 290,
  },
  menuItemIcon: {
    marginRight: 13,
  },
})

export default useSelectStyles
